module.exports = __webpack_public_path__ + "static/img/zhhq-jdglpt-02.79b8463.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zhhq-jdglpt-02.png
// module id = RKP4
// module chunks = 1